import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  readCompanySegment,
  updateCompanySegment,
  listCompanySegments,
  deleteCompanySegment,
} from '../../redux/actions/table/company_segments';
import { __, validateForm } from '../../core/utils';
import { setPlusActions } from '../../redux/actions/general/plus';
import EditCompanySegmentForm from '../../forms/company_segments/EditCompanySegmentForm';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import styles from '../../styles/views/company_segments/CompanySegments.scss';
import { get } from 'lodash';
import autobind from 'autobind-decorator';

const mapStateToProps = (state) => {
  return {
    table: state.table['company_segments'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.company_segments/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class CompanySegments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentDidMount() {
    listActiveModules();

    createSidebar({
      title: __('submenu.title.profile-settings'),
      items: [
        {
          title: __('submenu.title.company-details'),
          link: () => '/company/details',
        },
        {
          title: __('submenu.title.offices'),
          link: () => '/company/offices',
        },
        {
          title: __('company-settings.submenu.title.brands'),
          link: () => '/company/brands',
        },
        {
          title: __('company-settings.submenu.title.disciplines'),
          link: () => '/company/disciplines',
        },
        {
          title: __('submenu.title.market'),
          link: () => '/company/market',
        },
        {
          title: __('submenu.title.company_holidays'),
          link: () => '/company/company_holidays',
        },
        {
          title: __('submenu.title.company_positions'),
          link: () => '/company/company_positions',
        },
        {
          title: __('submenu.title.company_segments'),
          link: () => '/company/company_segments',
          active: true,
        },
        {
          title: __('submenu.title.company_benefits'),
          link: () => '/company/company_benefits',
        },
        {
          title: __('submenu.title.company_folders'),
          link: () => '/company/company_folders',
        },
        _.includes(
          this.props.auth?.permissions,
          'view.permissions.in.permission.manager'
        )
          ? {
              title: __('submenu.title.company_roles_and_permissions'),
              link: () => '/company/company_roles_and_permissions',
            }
          : null,
      ].filter(Boolean),
      // {
      //     title: __("submenu.title.subscription-and-billing"),
      //     link: () => "/company/subscription"
      // }
    });

    setPlusActions([
      {
        title: __('company_segments.table.button.create'),
        onClick: () =>
          this.props.actions.setTableParams({
            wizard_active: true,
          }),
      },
    ]);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readCompanySegment(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  @autobind
  _handleSubmit(formData) {
    return validateForm(
      updateCompanySegment(formData.id, _.omit(formData, ['id'])).then(() => {
        listCompanySegments();

        readCompanySegment(getURLParam('id')).then(({ response }) => {
          this.setState({ preview: response.data });
        });

        setNotification(
          __('company-settings.segments.notification.success-saved')
        );
      })
    );
  }

  render() {
    const columns = [
      {
        key: 'name',
        name: __('table.columns.company-segment.name'),
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
      {
        key: 'abbreviation',
        name: __('table.columns.company-segment.abbreviation'),
        width: 500,
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
    ];

    const singleActions = (id) => {
      let actions = [];

      actions.push([
        <Tooltip
          text={__('table.segments.actions.delete.tooltip')}
          key={_.uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __(
                  'table.segments.actions.delete.tooltip.this-process-cannot-undone'
                ),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deleteCompanySegment(id).then(() => {
                        hideAlertbox();

                        setNotification(
                          __(
                            'table.segments.actions.delete.selected-company-segment-deleted'
                          )
                        );
                        listCompanySegments();

                        this.props.actions.setTableParams({
                          selected_rows: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ]);

      return actions;
    };

    const preview = (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span>
              <strong>{get(this.state, 'preview.name')}:</strong>{' '}
              {get(this.state, 'preview.abbreviation')}
            </span>
            <CloseBigIcon
              onClick={() =>
                this.props.actions.setTableParams({
                  clicked_row: undefined,
                })
              }
            />
          </div>
        </div>
        <div className={styles.scroller}>
          <div className={styles.form}>
            <EditCompanySegmentForm
              onSubmit={this._handleSubmit}
              initialValues={_.pick(get(this.state, 'preview'), [
                'id',
                'name',
                'abbreviation',
              ])}
            />
          </div>
        </div>
      </div>
    );

    return (
      <Table
        listAction={listCompanySegments}
        name='company_segments'
        title={__('submenu.title.company_segments')}
        columns={columns}
        singleActions={singleActions}
        preview={get(this.state, 'preview') ? preview : []}
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default CompanySegments;
